/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PendTransactionRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {PendTransactionResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const pendTransaction = (request: PendTransactionRequest, options?: CashRequestOptions) => post<PendTransactionRequest, PendTransactionResponse>("/2.0/cash/pend-transaction", request, {...options, rejectOnError: true })